/* eslint-disable @typescript-eslint/ban-ts-comment */
import { useEffect, useState } from 'react';
import Button from "../../Shared/Button";
import Input from "../../Shared/Input";
import TextArea from "../../Shared/TextArea";
import MultiSelectbox from '../../Shared/MultiSelectBox';
import { useFormik } from "formik";
import { useMutation, useQuery } from "@tanstack/react-query";
import * as Yup from "yup";
import Spinner from "../../Shared/Spinner";
import { toast } from "react-toastify";
import { queryClient } from "../../../main";
import { getCourses } from "../../../api/Courses/GetAllCourses";
import { ButtonTypes } from '../../../utils/consts';
import { AddNewPackage } from '../../../api/Packages/AddPackage';
import { GetPackageById } from '../../../api/Packages/GetPackageById';
import { useParams } from 'react-router-dom';
import { EditPackage } from '../../../api/Packages/EditPackage';
import { PackageDTO } from '../../../api/Packages/GetAllPackages';
import { useNavigate } from 'react-router-dom';
import { Switch } from '@headlessui/react'
import UploadComponent from '../../Shared/Upload';
interface option {
  id?: string;
  name: string;
}

const validationSchema = Yup.object({
  name: Yup.string().required("Course name is required"),
  description: Yup.string().required("Course description is required"),
  img_url: Yup.string().required("Image Url is required"),
  actualPrice_egp: Yup.string().required("Price is required"),
  actualPrice_usd: Yup.string().required("Price is required"),
});

const AddPackage = ({ onSuccess }: { onSuccess?: () => void }) => {
  const { id } = useParams()
  const navigate = useNavigate()
  const [enabled, setEnabled] = useState(false)
  const packageId = id || ''
  const { data: CoursesResponse } = useQuery({
    queryFn: getCourses,
    queryKey: ["courses"],
    staleTime: 0,
    refetchInterval: 0,
  });
  const courses = CoursesResponse?.data?.coursesData || [];
  const [selectedCourses, setSelectedCourses] = useState<option[]>([]);

  const courseOptions = courses.map((course: option) => ({
    id: course.id,
    name: course.name,
  }));
  const { data: PackageById, isLoading: isPackageLoading } = useQuery({
    queryFn: () => GetPackageById(packageId),
    queryKey: ["package", packageId],
    staleTime: 0,
    refetchInterval: 0,
    enabled: !!id,
  });
  const packageDetails = PackageById?.data?.pacakgeData;
  useEffect(() => {
    if (packageDetails) {
      setEnabled(packageDetails.isTrending || false);
    }
  }, [packageDetails]);

  useEffect(() => {
    if (packageDetails) {
      formik.setValues({
        name: packageDetails.name,
        description: packageDetails.description,
        img_url: packageDetails.img_url,
        actualPrice_egp: packageDetails.actualPrice_egp,
        actualPrice_usd: packageDetails.actualPrice_usd,
        isTrending: packageDetails.isTrending || enabled,
      });
      setSelectedCourses(
        packageDetails.courses.map(course => {
          const fullCourse = courses.find((c) => c.id === course.id);
          return fullCourse || course;
        })
      );
      }
  }, [packageDetails]);

  const { mutate, isPending } = useMutation({
    mutationFn: AddNewPackage,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["package"] });
      toast.success("Package added successfully");
      formik.resetForm();
      onSuccess && onSuccess();
    },
    onError: () => {
      formik.setSubmitting(false);
    },
  });
  const { mutate: editMutate, isPending: isEditPending } = useMutation({
    mutationFn: (data : PackageDTO) => EditPackage(data, packageId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["package"] });
      toast.success("Package updated successfully");
      formik.setSubmitting(false);
      navigate('/dashboard/packages');
    },
    onError: () => {
      formik.setSubmitting(false);
    },
  });


  const formik = useFormik({
    initialValues: {
      name: "",
      description: "",
      img_url:"",
      actualPrice_egp: "",
      actualPrice_usd: "",
      isTrending: packageDetails?.isTrending || enabled,
    },
    validationSchema,
    onSubmit: (values) => {
      const packageData = {
        ...values,
        courses: selectedCourses.map(course => ({
          id: course.id,
        })),
        };
      if (packageId) {
        //@ts-expect-error
        editMutate(packageData);
      } else {
        mutate(packageData);
      }
    },
  });
  const handleTrendingToggle = (value: boolean) => {
    setEnabled(value);
    formik.setFieldValue("isTrending", value);
  };

  const handleimgUrlUpload = (url: string) => {
    formik.setFieldValue('img_url', url);
  };

  if (isPackageLoading)
    return (
      <div className="min-h-screen flex items-center justify-center">
        <Spinner />
      </div>
    );

  return (
    <form onSubmit={formik.handleSubmit} className="pt-5">
      <div className="flex justify-between mb-6">
        <h1 className="text-burntBlack font-bold text-[32px] mt-5">
        {packageId ? 'Edit Package' : 'Add New Package'}
        </h1>
      </div>
      <div className="p-8 rounded-3xl shadow bg-white border border-black/15 min-h-[70vh] flex gap-16">
        <div className="w-full">
          <h1 className="mb-2.5 font-bold text-2xl">Package info</h1>
          <p className="text-lightGray font-medium">
            Add package details down below
          </p>
          <div className="space-y-7 pt-8">
            <Input
              value={formik.values.name}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={
                formik.touched.name && formik.errors.name
                  ? formik.errors.name
                  : ""
              }
              className="text-lg font-semibold"
              inputStyles="bg-[#F5F6F8] !h-12 border-black/15 !rounded"
              title="Package Name"
              placeholder=""
              name="name"
              type="text"
            />
                        <UploadComponent folder="package_images" onFileUploaded={handleimgUrlUpload}>
              <Input
                upload={true}
                className="text-lg font-semibold"
                inputStyles="bg-[#F5F6F8] !h-12 border-black/15 !rounded"
                placeholder=""
                title="Package Image"
                name="img_url"
                type="text"
                value={formik.values.img_url}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={
                  formik.touched.img_url && formik.errors.img_url
                    ? formik.errors.img_url
                    : ""
                }
              />

            </UploadComponent>

            <TextArea
              value={formik.values.description}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={
                formik.touched.description && formik.errors.description
                  ? formik.errors.description
                  : ""
              }
              name="description"
              title="Package Description"
              placeholder=""
              inputStyles="!bg-[#F5F6F8] !h-[224px] border-black/15"
            />
            <div className="flex w-full gap-5">
              <Input
                value={formik.values.actualPrice_egp}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={
                  formik.touched.actualPrice_egp &&
                    formik.errors.actualPrice_egp
                    ? formik.errors.actualPrice_egp
                    : ""
                }
                className="text-lg font-semibold w-full"
                inputStyles="bg-[#F5F6F8] !h-12 border-black/15 !rounded"
                title="Price in EGP"
                placeholder=""
                name="actualPrice_egp"
                type="text"
              />
              <Input
                value={formik.values.actualPrice_usd}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={
                  formik.touched.actualPrice_usd &&
                    formik.errors.actualPrice_usd
                    ? formik.errors.actualPrice_usd
                    : ""
                }
                className="text-lg font-semibold w-full"
                inputStyles="bg-[#F5F6F8] !h-12 border-black/15 !rounded"
                title="Price in USD"
                placeholder=""
                name="actualPrice_usd"
                type="text"
              />
            </div>
            <MultiSelectbox
              title="Select Courses"
              className="text-lg font-semibold bg-[#F5F6F8] !h-12 border-black/15 !rounded"
              selectOptions={courseOptions}
              selected={selectedCourses}
              setSelected={setSelectedCourses}
              placeholder="Select courses"
            />
                        <div className={`md:space-y-2 space-y-1.5 relative font-medium`}>
              <h1 className="text-burntBlack md:text-base text-sm">
                Is Trending
              </h1>
              <Switch
                checked={enabled}
                onChange={handleTrendingToggle}
                className={`${enabled ? 'bg-secondary' : 'bg-primary'}
          relative inline-flex h-[38px] w-[74px] shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus-visible:ring-2  focus-visible:ring-white/75`}
              >
                <span
                  aria-hidden="true"
                  className={`${enabled ? 'translate-x-9' : 'translate-x-0'}
            pointer-events-none inline-block h-[34px] w-[34px] transform rounded-full bg-white shadow-lg ring-0 transition duration-200 ease-in-out`}
                />
              </Switch>
            </div>
            <Button
              className="!h-14 w-full !text-lg font-bold rounded-md !bg-[#4379EE] hover:!bg-primary"
              variant="primary"
              type={ButtonTypes.SUBMIT}
              disabled={formik.isSubmitting || isPending || isEditPending}
            >
              Done {isPending || isEditPending ? <Spinner /> : ""}
              </Button>
          </div>
        </div>
        <div></div>
      </div>
    </form>
  );
};

export default AddPackage;
